import { fetchRequest } from "@/plugins/fetchRequest";

const actions = {
  getSession({ commit }: StoreProp) {
    return new Promise((resolve, reject) => {
      fetchRequest({ url: "/payment/session", method: "get" })
        .then((responseData = {}) => {
          const { sessionId } = responseData.data || responseData;
          if (commit) {
            commit("UPDATE_SESSION", { sessionId });
            resolve(sessionId);
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  }
};

export default actions;
